import React, { useState, useEffect, useContext, createContext } from "react";

const widgetContext = createContext()

export function ProvideWidget({children}) {
    const widget = useProvideWidget()
    return <widgetContext.Provider value={widget}>{children}</widgetContext.Provider>;
}

export const useWidget = () => {
    return useContext(widgetContext)
}

function useProvideWidget() {

    const [widgetName, setWidgetName] = useState(null);
    const setWidget = (username) => {
        setWidgetName(username)
    }

    return {
        setWidget,
        widgetName
    }
}